// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { settings } from '@alme/ui-web/settings/settings-util';
function calculateXPosition() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const xPos = settings.Window.defaultPosition.xPos;
    const bufferedAgentWidth = parseInt(settings.Window.defaultSize.width, 10) + parseInt(xPos, 10);

    const bufferSize = 10;

    if (windowWidth <= (bufferedAgentWidth + bufferSize)) {
        return bufferSize;
    }
    return windowWidth - bufferedAgentWidth + "px";
}

function calculateYPosition() {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const yPos = settings.Window.defaultPosition.yPos;
    const bufferedAgentHeight = parseInt(settings.Window.defaultSize.height, 10) + parseInt(yPos, 10);

    const bufferSize = 10;

    if (windowHeight <= (bufferedAgentHeight + bufferSize)) {
        return bufferSize;
    }
    return windowHeight - bufferedAgentHeight + "px";
}
function setupState(components) {
    return  {
        [settings.stateLocations.Conversation.Base]: {
            [settings.stateLocations.Conversation.accessKey]: "",
            [settings.stateLocations.Conversation.inputProcessing]: [],
            [settings.stateLocations.Conversation.processedInput]: [],
            [settings.stateLocations.Conversation.processedResponse]: null,
            [settings.stateLocations.Conversation.receivedResponse]: null,
            [settings.stateLocations.Conversation.sentInput]: null,
            [settings.stateLocations.Conversation.sessionId]: null,
            [settings.stateLocations.Conversation.userId]: null,
            [settings.stateLocations.Conversation.language]: "",
            [settings.stateLocations.Conversation.isActiveSession]: false,
            [settings.stateLocations.Conversation.channel]: components.mobileDeviceDetector.getDeviceType() === settings.mobileConstants.deviceTypes.desktop ?
                settings.channelConstants.channels.Web : settings.channelConstants.channels.MobileWeb,    
        },
        [settings.stateLocations.ClientCommunicator.Base]: {
            [settings.stateLocations.ClientCommunicator.ReceivedMessages]: [],
            [settings.stateLocations.ClientCommunicator.AllowedOrigins]: "*",
        },
        [settings.stateLocations.History.Base]: {
            [settings.stateLocations.History.Messages]: [],
            [settings.stateLocations.History.RawMessages]: [],
            [settings.stateLocations.History.feedbackPanes]: [],
            [settings.stateLocations.History.displayFeedback]: false,
        },
        [settings.stateLocations.PersistentStorage.Base]: {

        },
        [settings.stateLocations.Window.Base]: {
            [settings.stateLocations.Window.IsEmbedded]: false,
            [settings.stateLocations.Window.disableLaunchEvents]: false,
            [settings.stateLocations.Window.platformId]: "UPoint",
            [settings.stateLocations.Window.AlmeMessage.Base]: {
                [settings.stateLocations.Window.AlmeMessage.shouldDisable]: false,
            },
            [settings.stateLocations.Window.MinimizeButton.Base]: {
                [settings.stateLocations.Window.MinimizeButton.shouldDisable]: false,
            },   
            [settings.stateLocations.Window.CallToActionButton.Base]: {
                [settings.stateLocations.Window.CallToActionButton.shouldDisable]: {},
            },
            [settings.stateLocations.Window.DisplayLinks.Base]: {
                [settings.stateLocations.Window.DisplayLinks.shouldDisable]: false,
            },
            [settings.stateLocations.Window.DisplayLinksUrl.Base]: {
                [settings.stateLocations.Window.DisplayLinksUrl.shouldDisable]: false,
            },
            [settings.stateLocations.Window.NavUrl.Base]: {
                [settings.stateLocations.Window.NavUrl.shouldDisable]: false,
            },
            [settings.stateLocations.Window.InlineSurveyLinks.Base]: {
                [settings.stateLocations.Window.InlineSurveyLinks.shouldDisable]: {},
            },
            [settings.stateLocations.Window.IsMinimized]: true,
            [settings.stateLocations.Window.currentTree]: null,
            [settings.stateLocations.Window.isDragging]: false,
            [settings.stateLocations.Window.position]: {
                "xPos": calculateXPosition(),  //  AON-2303
                "yPos": calculateYPosition(),   //  AON-2303
            },
            [settings.stateLocations.Window.size]: {
                "height": settings.Window.defaultSize.height,
                "width": settings.Window.defaultSize.width,
            },
            [settings.stateLocations.Window.urlLastLaunchedFrom]: {},
            [settings.stateLocations.Window.Input.Base]: {
                [settings.stateLocations.Window.Input.CurrentInput]: null,
                [settings.stateLocations.Window.Input.StageLocation]: null,
                [settings.stateLocations.Window.Input.CurrentPlaceholder]: settings.textConstants.inputboxPlaceholderText,
                [settings.stateLocations.Window.Input.NeedsFocus]: false,
            },
            [settings.stateLocations.Window.initializationData.Base]: {
                [settings.stateLocations.Window.initializationData.initDataRetrieved]: {},
            },
            
            [settings.stateLocations.Window.productPayload.Base]: {
                [settings.stateLocations.Window.productPayload.payloadSaved]: false,
                [settings.stateLocations.Window.productPayload.customIVA.Base]:{
                    [settings.stateLocations.Window.productPayload.customIVA.IVAName]: "default",
                    [settings.stateLocations.Window.productPayload.customIVA.IVAAvatar]: "default",
                },
            },

            [settings.stateLocations.Window.InputBoxLocked.Base]: {
                [settings.stateLocations.Window.InputBoxLocked.isInputBoxLocked]: false,
                [settings.stateLocations.Window.InputBoxLocked.ReenableOnLinkClick]: true,
                [settings.stateLocations.Window.InputBoxLocked.ReenableWelcomeUser]: true,
            },


            [settings.stateLocations.Window.advocacyVariables.Base]: {
                [settings.stateLocations.Window.advocacyVariables.messagesGiven.Base]: {
                    [settings.stateLocations.Window.advocacyVariables.messagesGiven.birthAdoptChklstUrl]: false, 
                    [settings.stateLocations.Window.advocacyVariables.messagesGiven.addrChangeChklstUrl]: false,
                    [settings.stateLocations.Window.advocacyVariables.messagesGiven.divorceChklstUrl]: false,
                },
                [settings.stateLocations.Window.advocacyVariables.advocacyConfigData]: {},
            },

            [settings.stateLocations.Window.SkipToContent.Base] : {
                [settings.stateLocations.Window.SkipToContent.ShouldSkipToContent] : false,
            },

            [settings.stateLocations.Window.TimeoutWarning.Base]: {
                [settings.stateLocations.Window.TimeoutWarning.SessionStartTime]: null,
                [settings.stateLocations.Window.TimeoutWarning.Visible]: false,
            },
            [settings.stateLocations.Window.SkipToContent.Base]: {
                [settings.stateLocations.Window.SkipToContent.shouldDisable]: false,
                [settings.stateLocations.Window.SkipToContent.ShouldSkipToContent]: false,
            },
            [settings.stateLocations.Window.UserMessage.Base]: {
                [settings.stateLocations.Window.UserMessage.shouldDisable]: false,
            },
        },
        [settings.stateLocations.AutoNav.Base]: {},
        [settings.stateLocations.WelcomeUser.Base]: {
            [settings.stateLocations.WelcomeUser.launchPointName] : "",
        },
        [settings.stateLocations.Advocacy.Base]: {},
        [settings.stateLocations.OutputMasking.Base]: {},
        [settings.stateLocations.Initialization.Base]: {},
        [settings.stateLocations.AlmeNotifications.Base]: {},
        [settings.stateLocations.GenerateNewSession.Base] : {
            [settings.stateLocations.GenerateNewSession.resetEnabled] : true,
        },
        [settings.stateLocations.LiveChat.Base]: {
            //foundational settings
            [settings.stateLocations.LiveChat.sessionState]: settings.livechat.sessionState.offline,
            [settings.stateLocations.LiveChat.operatorData]: [],
            [settings.stateLocations.LiveChat.LastSeenIndex]: -1,
            [settings.stateLocations.LiveChat.queueText]: "",
        },
        [settings.stateLocations.FeedbackAppEvent.Base]: {
            [settings.stateLocations.FeedbackAppEvent.staging]: [],
        },
    
        [settings.stateLocations.DeviceType]: settings.mobileConstants.deviceTypes[settings.mobileConstants.deviceTypes.deviceDefault],
        [settings.stateLocations.Offers.Base] : {
            [settings.stateLocations.Offers.offersAvailable]: [],
            [settings.stateLocations.Offers.offersProvided]: [],
            [settings.stateLocations.Offers.offerData]: [],
        },
    };
}

export {
    setupState
};



// WEBPACK FOOTER //
// ./src/setup-state.js